import Vue from 'vue'
import VueRouter from "vue-router"
import { authDict } from '@/utils/authDiact'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}


const routes = [
    {
        path:'/',
        name:'/',
        redirect:'/login',
    },
    {
        path:'/login',
        name:'login',
        component:()=>import('@/pages/login/loginView.vue'),
    },
    {
        path:'/qr-verify',
        name:'qrVerify',
        component:()=>import('@/pages/qr/qrVerifyView.vue')
    },
    {
        path:'/home',
        name:'home',
        component:()=>import('@/pages/home/homeView.vue'),
        redirect:'/home/queue',
        children:[
            {
                path:'queue',
                name:'queue',
                component:()=>import('@/pages/queue/queueView.vue'),
                meta: { 
                    requiresLogin:true,  //是否需要登录
                    requiresAuth:true,  //是否需要权限
                    authRole:'visitor' //权限级别 visitor(访客)可查看  user(用户)可操作  admin(管理员)可管理账号界面
                } 
            },
            {
                path:'lane',
                name:'lane',
                component:()=>import('@/pages/lane/laneView.vue'),
                meta: { 
                    requiresLogin:true,
                    requiresAuth:true,
                    authRole:'visitor'
                } 
            },
            {
                path:'outLane',
                name:'outLane',
                component:()=>import('@/pages/outLane/outLaneView.vue'),
                meta: {
                    requiresLogin:true,
                    requiresAuth:true,
                    authRole:'visitor'
                }
            },
            {
                path:'allow',
                name:'allow',
                component:()=>import('@/pages/allow/allowView.vue'),
                meta: {
                    requiresLogin:true,
                    requiresAuth:true,
                    authRole:'visitor'
                }
            },
            {
                path:'queueHistory',
                name:'queueHistory',
                component:()=>import('@/pages/queueHistory/queueHistoryView.vue'),
                meta: { 
                    requiresLogin:true,
                    requiresAuth:true,
                    authRole:'visitor'
                }
            },
            {
                path:'account',
                name:'account',
                component:()=>import('@/pages/account/accountView.vue'),
                meta: { 
                    requiresLogin:true,
                    requiresAuth:true,
                    authRole:'admin'
                }
            },
            {
                path:'externalqueue',
                name:'externalqueue',
                component: () => import('@/pages/externalqueue/queueView.vue'),
                meta: { 
                    requiresLogin: true,
                    requiresAuth: true,
                    authRole: 'visitor'
                }
            },
            {
                path: 'incoming',
                name: 'incoming',
                component:()=>import('@/pages/external/incomingView.vue'),
                meta: { 
                    requiresLogin:true,
                    requiresAuth:true,
                    authRole:'visitor'
                }
            },
            {
                path: 'queueflow',
                name: 'queueflow',
                component:()=>import('@/pages/queue/queueflow.vue'),
                meta: {
                    requiresLogin:true,
                    requiresAuth:true,
                    authRole:'visitor'
                }
            },
        ]
    },
    {
        path:'/notAuth',
        name:'noutAuth',
        component:()=>import('@/pages/notAuth/notAuthView.vue'),
    },
    {
        path: '*', // 捕获所有未匹配的路由
        name:'notFound',
        component:()=>import('@/pages/notFound/notFoundView.vue'),
    },
]

const router = new VueRouter({
    mode:'history',
    routes:routes
})

router.beforeEach((to, from, next) => {
    let oldV = localStorage.getItem('version')
    fetch('/version.json').then(res=>{   
        return res.json()
    }).then(data=>{
        console.log(oldV,data.version)
        if(oldV!=data.version){
            //如果有更新，保存最新版本
            localStorage.setItem('version',data.version)
            //帮用户刷新页面，更新缓存版本
            window.location.reload()
        }
    })

    //检查localStorage或者状态管理库中是否存在token
    const isLogined = window.localStorage.getItem('token')?JSON.parse(window.localStorage.getItem('token')):null
    
    if(to.matched.some(record => record.meta.requiresLogin)&&!isLogined){
        //用户未登录
        next({
            path: '/login',
            query: { redirect: to.fullPath } // 将用户原本想要访问的页面记录下来
        })
    }else{
        const haveAuthRole = window.localStorage.getItem('authRole')?JSON.parse(window.localStorage.getItem('authRole')):null
        let {  authRole:needAuthRole } = to.meta
        if(to.meta.requiresAuth&&authDict[haveAuthRole]<authDict[needAuthRole]){
            //用户没有权限
            next({
                path: '/notAuth'
            })
        }else{
            next() //确保一定要调用 next()
        }
    }
})

export default router